import React, {useEffect, useState, useContext} from 'react';
import axios from 'axios';
import API_BASE_URL from '../../utils/apiBaseUrl';
import { ListGroup } from 'react-bootstrap';
import { TrophyFill, Fire, Snow, Bullseye } from 'react-bootstrap-icons';
import './Standings.css';
import { AccountContext } from './../../components/UserPool/Account';
import UserInfoModal from '../../components/UserInfoModal/UserInfoModal';
import AlertModal from '../../components/AlertModal/AlertModal';

// API article https://medium.com/swlh/skip-lambda-save-data-to-dynamodb-directly-using-api-gateway-process-later-with-streams-dab2ceef9a9d
function Standings({year}) {
    const { getSession } = useContext(AccountContext);
    const [newSession, setNewSession] = useState(undefined);

    const [startStreak, setStartStreak] = useState([]);
    const [mostCorrect, setMostCorrect] = useState([]);

    const [standings, setStandings] = useState({});

    const [showModal, setShowModal] = useState(false);
    const [showSpinnerInModal, setShowSpinnerInModal] = useState(true);
    const [fullUserInfo, setFullUserInfo] = useState(undefined);

    const [showStandingsAlertModal, setShowStandingsAlertModal] = useState([false, '', ''])

    useEffect(() => {
        getSession(setNewSession)
          .then((session) => {
            console.log('Session Activated');
          })
          .catch((err) => {
            console.log('Session: ', err);
          });
        
      }, []);

    // API: get payoutsArr
    const [payoutsArr, setPayoutsArr] = useState([
        'Longest Start Streak: $',
        'Second Longest Start Streak: $',
        'Most Correct: $',
        'Second Most Correct: $'
    ]);      

    // API: get payoutsArr
    const [moneyDistributionArr, setMoneyDistributionArr] = useState([
        'Longest Start Streak: $',
        'Second Longest Start Streak: $',
        'Most Correct: $',
        'Second Most Correct: $'
    ]);

    function getUserInfo(user) {
        setShowModal(true);
        axios.get(`${API_BASE_URL}/user-info-standings`, {
            headers: {
                Authorization: newSession['idToken']['jwtToken'],
                'Content-Type': 'application/json',
            },
            params: {user, year}
        }).then((response) => {
            setFullUserInfo(response['data']);
            setShowSpinnerInModal(false);
        }).catch((error) => {
            console.log(error); 
            setShowStandingsAlertModal([true, 'Unable to get user info. Refresh the page and try again.', 'We\'ve hit a snag'])
        })
    }

    function getPayoutTiers(currStreakArr, isMostCorrect) {
        let tierNum = 1;
        let highScore = -1;
        let firstTier = '';
        let secondTier = '';
        let val;
        let currUser;
        let currStreak;

        let firstTierLen = 0;
        for(let i = 0; i < currStreakArr.length; i++) {
            val = currStreakArr[i];
            currUser = Object.keys(val)[0];
            currStreak = isMostCorrect ? Object.values(val)[0] : Object.values(val)[0][0];
            if(currStreak > highScore) {
                firstTier = (firstTier === '') ? firstTier + currUser : firstTier + ', ' + currUser;
                highScore = currStreak;
                firstTierLen = 1;
            } else if(currStreak === highScore && tierNum === 1) {
                firstTier = (firstTier === '') ? firstTier + currUser : firstTier + ', ' + currUser;
                firstTierLen++;
            } else if(currStreak < highScore && tierNum === 1 && firstTierLen === 1) {
                secondTier = (secondTier === '') ? secondTier + currUser : secondTier + ', ' + currUser;
                highScore = currStreak;
                tierNum = 2;
            } else if(currStreak < highScore && tierNum === 1 && firstTierLen > 1) {
                secondTier = firstTier;
                break;
            } else if(currStreak === highScore && tierNum === 2) {
                secondTier = (secondTier === '') ? secondTier + currUser : secondTier + ', ' + currUser;                
            }
        };

        return [firstTier, secondTier]
    }


      useEffect(() => {
        if(newSession !== undefined) {
            const getStandings = () => {
                axios.get(`${API_BASE_URL}/standings`, {
                headers: {
                    Authorization: newSession['idToken']['jwtToken'],
                    'Content-Type': 'application/json'
                },
                params: {year}
                }).then((response) => {
                    console.log(response)
                    setStartStreak(response['data']['longest_start_streak']);
                    setMostCorrect(response['data']['most_correct']);
                    setStandings(response['data']);
                }).catch((error) => {
                    console.log(error); 
                    setShowStandingsAlertModal([true, 'Unable to standings. Refresh the page and try again.', 'We\'ve hit a snag'])
                })
            }
            getStandings()
        }
      }, [newSession]);

      useEffect(() => {
            let totalEntries = startStreak.length;
            let mostPayout = totalEntries * 6.25;
            let secondLongestPayout = Math.ceil(totalEntries * 2.77);
            
            let firstPayout = 25 * totalEntries - mostPayout - (secondLongestPayout * 2);

            setMoneyDistributionArr([
                'Longest Start Streak: $' + firstPayout.toFixed(2),
                'Second Longest Start Streak: $' + secondLongestPayout.toFixed(2),
                'Most Correct: $' + mostPayout.toFixed(2),
                'Second Most Correct: $' + secondLongestPayout.toFixed(2)
            ]);
            

            let startStreakTiers = getPayoutTiers(startStreak, false);
            let firstTierStartStreak = startStreakTiers[0];
            let secondTierStartStreak = startStreakTiers[1];

            let mostCorrectTiers = getPayoutTiers(mostCorrect, true);
            let firstTierMostStreak = mostCorrectTiers[0];
            let secondTierMostStreak = mostCorrectTiers[1];

            let numFirstStartCommas = 1 + (firstTierStartStreak.match(/,/g) || []).length;
            let numSecondStartCommas = 1 + (secondTierStartStreak.match(/,/g) || []).length;
            let numFirstMostCommas = 1 + (firstTierMostStreak.match(/,/g) || []).length;
            let numSecondMostCommas = 1 + (secondTierMostStreak.match(/,/g) || []).length;

            if (numFirstStartCommas > 5) {
                console.log(numFirstStartCommas)
                firstTierStartStreak = `${numFirstStartCommas} tied`
            }

            if (numSecondStartCommas > 5) {
                secondTierStartStreak = `${numSecondStartCommas} tied`
            }

            if (numFirstMostCommas > 5) {
                firstTierMostStreak = `${numFirstMostCommas} tied`
            }

            if (numSecondMostCommas > 5) {
                secondTierMostStreak = `${numSecondMostCommas} tied`
            }

            setPayoutsArr([
                'Longest Start Streak: ' + firstTierStartStreak + ' ($' +  (firstPayout / numFirstStartCommas).toFixed(2).toString() + ' each)',
                'Second Longest Start Streak: ' + secondTierStartStreak + ' ($' +  (secondLongestPayout / numSecondStartCommas).toFixed(2).toString() + ' each)',
                'Most Correct: ' + firstTierMostStreak + ' ($' +  (mostPayout / numFirstMostCommas).toFixed(2).toString() + ' each)',
                'Second Most Correct: ' + secondTierMostStreak + ' ($' +  (secondLongestPayout / numSecondMostCommas).toFixed(2).toString() + ' each)'
            ]);            
      }, [standings]);


    // "Competition ranking" -- tied entries share a rank (1, 1, 3), not a
    // fake tiebreak (1, 2, 3), since the pool genuinely splits ties.
    function withRanks(list, getValue) {
        let rank = 0;
        let prevValue = null;
        return list.map((entry, i) => {
            const value = getValue(entry);
            if (value !== prevValue) rank = i + 1;
            prevValue = value;
            return { entry, rank, value };
        });
    }

    const rankedStreaks = withRanks(startStreak, (val) => Object.values(val)[0][0]);
    const rankedMostCorrect = withRanks(mostCorrect, (val) => Object.values(val)[0]);

    let startStreakItems = rankedStreaks.map(({entry, rank, value}, i) => {
        const currUser = Object.keys(entry)[0];
        const isStreakAlive = Object.values(entry)[0][1];
        return (
            <li key={i+'-start-streak-arr'} role='button' onClick={() => getUserInfo(currUser)} className={'leaderboard-row' + (rank <= 3 ? ' top-three rank-' + rank : '')}>
                <span className='leaderboard-rank'>{rank}</span>
                <span className='leaderboard-name'>{currUser}</span>
                {
                    isStreakAlive
                        ? <Fire className='leaderboard-status-icon alive' title='Streak alive' />
                        : <Snow className='leaderboard-status-icon eliminated' title='Streak ended' />
                }
                <span className='leaderboard-value'>{value}</span>
            </li>
        );
    });

    let mostCorrectItems = rankedMostCorrect.map(({entry, rank, value}, i) => {
        const currUserMost = Object.keys(entry)[0];
        return (
            <li key={i+'-most-arr'} role='button' onClick={() => getUserInfo(currUserMost)} className={'leaderboard-row' + (rank <= 3 ? ' top-three rank-' + rank : '')}>
                <span className='leaderboard-rank'>{rank}</span>
                <span className='leaderboard-name'>{currUserMost}</span>
                <span className='leaderboard-value'>{value}</span>
            </li>
        );
    });

    let payoutsItems = []
    payoutsArr.forEach((val, i) => {
        payoutsItems.push(
            <ListGroup.Item key={i+'-payouts-arr'}>
                <div key='ah'>
                    {val.split(':')[0]}
                </div>
                <div key='ahhhh' className='payouts-item'>
                    {val.split(':')[1]}
                </div>
            </ListGroup.Item>
        );
    });

    let moneyDistItems = []
    moneyDistributionArr.forEach((val, i) => {
        moneyDistItems.push(
            <ListGroup.Item key={i+'-money-dist-arr'}>
                <div key='ahh'>
                    {val.split(':')[0]}
                </div>
                <div key='ahhh' className='payouts-item'>
                    {val.split(':')[1]}
                </div>
            </ListGroup.Item>
        );
    });

    return (
        <>
            <div className='main-section-standings'>
            <div className='page-header'>
                <h1 className='page-title'>Standings</h1>
                <p className='page-subtitle'>Start streaks, most correct, and payouts</p>
            </div>

            <div className='standings-grid'>
                <div className='standings-card leaderboard-card'>
                    <div className='standings-header-1'>
                        <TrophyFill className='standings-header-icon streak' />
                        Longest Start Streak
                    </div>
                    <ul className='leaderboard-list'>
                        {startStreakItems}
                    </ul>
                </div>

                <div className='standings-card leaderboard-card'>
                    <div className='standings-header-1'>
                        <Bullseye className='standings-header-icon correct' />
                        Most Correct
                    </div>
                    <ul className='leaderboard-list'>
                        {mostCorrectItems}
                    </ul>
                </div>
            </div>

            <div className='standings-grid'>
                <div className='standings-card'>
                    <div className='standings-header-1'>Current Payouts</div>
                    <ListGroup variant='flush'>
                        {payoutsItems}
                    </ListGroup>
                </div>

                <div className='standings-card'>
                    <div className='standings-header-1'>Money Distribution</div>
                    <ListGroup variant='flush'>
                        {moneyDistItems}
                    </ListGroup>
                </div>
            </div>

            <UserInfoModal
                fullUserInfo={fullUserInfo}
                showModal={showModal}
                setShowModal={setShowModal}
                showSpinnerInModal={showSpinnerInModal}
                setShowSpinnerInModal={setShowSpinnerInModal}
                setFullUserInfo={setFullUserInfo}
                year={year}
            />
            <AlertModal
                show={showStandingsAlertModal[0]}
                onHide={()=>{setShowStandingsAlertModal([false, '', ''])}}
                modalTitle={showStandingsAlertModal[2]}
                modalBody={showStandingsAlertModal[1]}
            />
            </div>
        </>
    )
}

export default Standings;